// Веб-вклад модуля `trash` — единая корзина (30 дней).
//
// Системная группа навигации — последняя. Счётчика нет: число «сколько лежит в
// корзине» не побуждает к действию и только шумит.

import { SECTION_ICONS } from "@/components/navigation/section-icons";
import type { WebModuleManifest } from "./_contract";

export const trashWebManifest = {
	id: "trash",
	icon: SECTION_ICONS.trash,
	labelKey: "nav.trash",
	routes: ["/trash"],

	// Баннер объясняет МЕХАНИКУ каскада: удаление источника уносит всё, что из
	// него собрано, — этого не видно ни из названия, ни из списка. Срок 30 дней
	// сюда НЕ дублируется: он уже стоит в подзаголовке раздела.
	// Вкладки справки нет: корзина не относится ни к методу, ни к сбору курса,
	// ни к инструментам обучения — ссылка вела бы в никуда.
	intro: {
		titleKey: "trash:intro.title",
		bodyKey: "trash:intro.body",
		bulletKeys: ["trash:intro.bullets.0", "trash:intro.bullets.1", "trash:intro.bullets.2"],
	},

	nav: [
		{
			key: "trash",
			to: "/trash",
			icon: SECTION_ICONS.trash,
			labelKey: "nav.trash",
			order: 10,
		},
	],
} satisfies WebModuleManifest;
